import { AxiosError } from 'axios';
import { ApiErrorBody } from 'types/api';

const GENERIC_ERROR = 'No pudimos completar la operación. Intentá de nuevo.';

export const getApiErrorMessage = (error: unknown, fallback = GENERIC_ERROR): string => {
  if (!error) return fallback;

  if (typeof error === 'string') return error;

  if (error instanceof Error && !(error as AxiosError).isAxiosError && error.message) {
    return error.message;
  }

  const axiosError = error as AxiosError<ApiErrorBody>;
  const status = axiosError.response?.status;
  const data = axiosError.response?.data;

  if (status !== undefined && status >= 400 && status < 500) {
    if (data?.message) return data.message;
    if (data?.detail) return data.detail;
    if (data?.title && data.title !== 'Bad Request') return data.title;
    if (data?.errors) {
      const first = Object.values(data.errors)[0];
      if (first?.[0]) return first[0];
    }
  }

  if (!axiosError.response || (status !== undefined && status >= 500)) {
    console.error('API error detail:', axiosError.message, data ?? error);
    if (data?.message) return data.message;
    if (data?.detail) return data.detail;
    return fallback;
  }

  if (data?.message) return data.message;
  if (data?.title) return data.title;

  console.error('API error detail:', axiosError.message, data ?? error);
  return fallback;
};
